import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app.tsx';
import { startSending } from './offline.ts';
import './styles.css';

const root = document.getElementById('app');
if (root) createRoot(root).render(<StrictMode><App /></StrictMode>);

// Anything recorded while the signal was down goes as soon as it comes back.
startSending();

/*
 * The app itself has to load with no connection, or a tablet that goes to sleep in a corridor
 * comes back to a blank screen in the middle of a round. Registered after the first paint so it
 * never delays one.
 */
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/app/sw.js', { scope: '/app/' }).catch(() => {
      // No service worker is a loss of offline loading, not of anything recorded. Carry on.
    });
  });
}
